import { OrderDirectionEnum, VendorDirectionEnum } from 'generated/api'
import { ArrowDown2, ArrowUp2 } from 'iconsax-react'

interface PropsIconSortAscDesc {
  columnName: string
  columnSortField: string
  columnSortBy: OrderDirectionEnum | VendorDirectionEnum
}

function IconSortAscDesc(props: PropsIconSortAscDesc) {
  const iconSize = 12
  const iconColor = '#202020'
  const iconVariant = 'Outline'
  const { columnName, columnSortField, columnSortBy } = props
  const directionASC = OrderDirectionEnum.Asc || VendorDirectionEnum.Asc

  if (columnName === columnSortField) {
    if (columnSortBy === directionASC) {
      return <ArrowUp2 size={iconSize} color={iconColor} variant={iconVariant} />
    } else {
      return <ArrowDown2 size={iconSize} color={iconColor} variant={iconVariant} />
    }
  }

  return (
    <div className="flex flex-col">
      <ArrowUp2 size={iconSize} color={iconColor} variant={iconVariant} />
      <ArrowDown2 size={iconSize} color={iconColor} variant={iconVariant} />
    </div>
  )
}

export default IconSortAscDesc
